import React from 'react';

function WhyChoose() {
  const reasons = [
    { icon: '🚐', text: 'Modern, well-maintained fleet' },
    { icon: '👨‍✈️', text: 'RTA-approved professional drivers' },
    { icon: '🕐', text: '24/7 customer support' },
    { icon: '💰', text: 'Competitive pricing' },
    { icon: '⏰', text: 'On-time service guarantee' },
    { icon: '📦', text: 'Flexible rental packages' },
    { icon: '🇦🇪', text: 'Full UAE coverage' },
    { icon: '🛡️', text: 'Safety-focused operations' }
  ];

  return (
    <section className="why-choose-section">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title-white">Why Choose Us</h2>
        </div>
        <div className="row">
          {reasons.map((item, idx) => (
            <div key={idx} className="col-lg-6 mb-4">
              <div className="why-choose-item">
                <div className="why-choose-icon">{item.icon}</div>
                <p>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChoose;